import { Error, Refresh } from '@mui/icons-material';
import { WOrderErrorPage } from '@pinnacleautomotive/clarity-components';
import { useTranslation } from 'react-i18next';

const WOrderError500Page = () => {
  const { t } = useTranslation(['orders', 'global']);
  return (
    <WOrderErrorPage
      iconLabel={
        <Error
          style={{
            fontSize: '72px',
            color: '#F44336',
            marginBottom: '32px',
          }}
        />
      }
      titleLabel={t('newOrder.error500Labels.titleLabel')}
      subtitleLabel={t('newOrder.error500Labels.subTitleLabel')}
      buttonLabel={
        <>
          <Refresh />
          {t('newOrder.error500Labels.buttonLabel')}
        </>
      }
      onClickError={() => window.location.reload()}
    />
  );
};

export default WOrderError500Page;
